import styled from 'styled-components';
import React from 'react';
import { WebinarType } from '../../models/webinars';
import convertEmbeddedLink from '../../utils/embeddedLinkUtils';
import { WebinarPropType } from '../../models/types/webinars';

const locale = 'en';

const EmbeddedVideo = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const EmbeddedVideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  margin-bottom: 24px;
`;

const WebinarMedia = ({ webinar }) => (
  webinar.kind === WebinarType.OnDemand && (
    <EmbeddedVideoContainer>
      <EmbeddedVideo
        src={convertEmbeddedLink(webinar.translations[locale].url)}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </EmbeddedVideoContainer>
  )
);

WebinarMedia.propTypes = {
  webinar: WebinarPropType.isRequired,
};

export default WebinarMedia;
